import { LocalizedBetForAnalysisResponse, Selection } from '../../types/generated/nikeone';

export const isSelectionPopular = (selection: Selection) => {
    const flags = selection?.flags;
    return flags && (flags.includes('Top5') || flags.includes('Naj10') || flags.includes('Popular'));
};

export const formatOdds = (odds: number) => {
    if (odds === null || odds === undefined) {
        return false;
    } else if (typeof odds === 'string') odds = parseFloat(odds);

    return odds.toFixed(2);
};

// filter grid - returns single selection (with label if present)
export const getSingleSelection = (
    selectionGrid: LocalizedBetForAnalysisResponse['selectionGrid'],
    selectionCode: string
) => selectionGrid && selectionGrid.flat().filter(sel => sel.type === 'label' || sel.tip === selectionCode);

export const getBoxesRefreshTime = () => window?.OPTIONS?.nikeone?.prematchConfig?.boxes_refresh_time;

export const validState = (state: any): boolean => String(state).toLowerCase() !== 'hidden';
